import { useSearchOrdersQuery } from 'API/order/OrderApi';
import React, { useMemo } from 'react';
import { Button, SpinnerSize } from 'ui-toolkit';
import { SpinnerTW } from 'tailwindComponents/spinnerTW/SpinnerTW';
import { SearchBarOrderTable } from './SearchBarOrderTable';
import { createDefaultSearchOrderSpecification } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';
import { ISearchOrderRequest } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrder';

export interface ISearchBarOrderSearchProps {
  title: string;
  currentSearch: string[];
  emptyMessage: string;
  remove?: (fileNumber: string) => void;
  clear?: () => void;
}

export const SearchBarOrderSearch: React.FC<ISearchBarOrderSearchProps> = ({
  title,
  currentSearch,
  emptyMessage,
  remove,
  clear,
}) => {
  const search = { fileNumbers: currentSearch };
  const { data, isLoading } = useSearchOrdersQuery(
    {
      ...createDefaultSearchOrderSpecification(),
      pageSize: 10,
      ...search,
    },
    { skip: currentSearch.length === 0 }
  );
  const orders = useMemo(() => {
    const orderResults = data?.content ?? [];
    if (search.fileNumbers.length === 1) {
      return orderResults;
    }

    return currentSearch
      .map((t) => orderResults.find((orderResult) => orderResult.fileNumber === t))
      .filter((t) => !!t)
      .map((t) => t as ISearchOrderRequest);
  }, [data, currentSearch, search.fileNumbers.length]);

  return (
    <div>
      {isLoading && <SpinnerTW size={SpinnerSize.small} />}
      {!isLoading && (
        <div>
          {orders.length === 0 && <div className={'italic'}>{emptyMessage}</div>}
          {orders.length > 0 && (
            <>
              <div className={'flex flex-row justify-between'}>
                <div className={'font-semibold italic'}>{title}</div>
                {clear && (
                  <div>
                    <Button isInline intent={'ghost'} onClick={clear} data-test-id={`Clear-SearchBar-${title}`}>
                      clear
                    </Button>
                  </div>
                )}
              </div>
              <SearchBarOrderTable orders={orders} remove={remove} dataTestId={`SearchBar-${title}`} />
            </>
          )}
        </div>
      )}
    </div>
  );
};
